export default __webpack_public_path__ + "static/media/dark-pencil.a9ba82f7.svg";